function getHead(vm, route) {
  const { head } = vm.$options
  if (head) {
    return typeof head === 'function' ? head.call(vm, route) : head
  }
}

function setClientHead(head) {
  if (head) {
    let { title, description, keywords } = head
    if (title) document.title = title
    if (description && document.querySelector('meta[name="description"]'))
      document
        .querySelector('meta[name="description"]')
        .setAttribute('content', description)
    if (keywords && document.querySelector('meta[name="keywords"]'))
      document.querySelector('meta[name="keywords"]').setAttribute('content', keywords)
  }
}

const serverHeadMixin = {
  created() {
    // console.log('==serverHeadMixin==')
    const head = getHead(this, this.$route)
    if (head) {
      let { title, description, keywords } = head
      let metaStr = ''
      if (title) this.$ssrContext.title = title
      if (description) {
        metaStr += `<meta name="description" content="${description}">`
      }
      if (keywords) {
        metaStr += `<meta name="keywords" content="${keywords}">`
      }
      this.$ssrContext.meta = metaStr
    }
  }
}

const clientHeadMixin = {
  beforeRouteUpdate(to, from, next) {
    const head = getHead(this, to)
    setClientHead(head)
    next()
  },
  mounted() {
    const head = getHead(this, this.$route)
    setClientHead(head)
  }
}
console.log(" process.env.VUE_ENV ===",  process.env.VUE_ENV)

export default process.env.VUE_ENV === 'server' ? serverHeadMixin : clientHeadMixin



// WEBPACK FOOTER //
// ./src/mixins/head.js